<iboxtools *ngIf="verDetalle" [Title]="" 
            isHistory='true' 
            [enableBack]="true" 
            [DateInit]="deduccion?.desde" 
            [DateEnd]="deduccion?.hasta"
            [IsEditing]="isEditing" 
            (BackChange)="OnBackChange()" 
            [PeriodList]="deduccionesHistoryList" 
            (DeleteChange)="OnDeleteChange($event)" 
            (NewChange)="OnNewChange($event)"
            (EditChange)="OnEditChange($event)" 
            (PeriodChange)="OnPeriodChange($event)" 
            (CancelChange)="OnCancelChange($event)" 
            (SaveChange)="OnSaveChange($event)" 
            (CutChange)="OnCutChange()"
            [Permiso]="permisoEdicion"
            [CurrentPeriod]="deduccion?.id">
</iboxtools>

<app-deduciones-iigg-list *ngIf="!verDetalle && !buscando" [personalId]="personalId" 
                                                             [deducciones]="deducciones" 
                                                             [permisoEdicion]="permisoEdicion"
                                                             (VisualizarDetalle)="OnVisualizarDetalle($event)">
</app-deduciones-iigg-list>

<app-deduciones-iigg-detalle #ChildDeduccionesIIGGDetalle [deduccion]="deduccion" *ngIf="verDetalle" 
                            [enabledForm]="habilitarFormDetalle" 
                            [MensajeError]="MensajeError" 
                            [desdeAnterior]="desdeAnterior" 
                            [ingreso]="ingreso"
                            [anteriorRetroactividad]="anteriorRetroactividad" 
                            [grupoLiq]="gruposLiquidaciones"
                            [deduccionesInvalida]="deduccionesInvalida">
</app-deduciones-iigg-detalle>

